import * as types from '../mutation-types'
import shop from '../../api/shop'

const state = {
	address: {}
}

// getters
const getters = {
  myAddress: state => state.address || {}
}

// actions
const actions = {
  getMyAddresses({ commit, state }, forCustomer) {
	  shop.getAddresses(forCustomer, function (address) {
      commit(types.GET_ADDRESSES, { address : address })
    })
  },
  saveAddress({ commit, state }, { address: newAddress, forCustomer }) {
    const {phone, contact, address} = newAddress
    shop.newAddress(forCustomer, {tel: phone, name: contact, street: address}, (address)=> {
        // this.$router.push('/checkout');
        commit(types.NEW_ADDRESSES, address)
    })
  },
  editAddress({ commit, state }, { address: newAddress, forCustomer }) {
    const {phone, contact, address, _id} = newAddress
    shop.editAddress(forCustomer, {tel: phone, name: contact, street: address, _id}, (address)=> {
        // this.$router.push('/checkout');
        commit(types.EDIT_ADDRESSES, address)
    })
  },
  updateAddress({ commit, state }, {phone, contact, address}) {
    let address1 = JSON.parse(JSON.stringify(state.address));
    address1.attributes.line_1=contact;
    address1.attributes.line_2 = phone;
    address1.attributes.line_3 = address;
    shop.updateAddresses(address1[0]);
  },
}

const mutations = {
  [types.GET_ADDRESSES] (state, address) {
    state.address = address.address
  },
  [types.NEW_ADDRESSES] (state, address) {
    state.address = address
  },
  [types.EDIT_ADDRESSES] (state, address) {
    state.address = address
  },
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/addresses.js